const GET_AZURE_LOAD_BALANCER = "GET_AZURE_LOAD_BALANCER";
const GET_AZURE_LOAD_BALANCER_SUCCESS = "GET_AZURE_LOAD_BALANCER_SUCCESS";
const GET_AZURE_LOAD_BALANCER_ERROR = "GET_AZURE_LOAD_BALANCER_ERROR";

export {
  GET_AZURE_LOAD_BALANCER,
  GET_AZURE_LOAD_BALANCER_SUCCESS,
  GET_AZURE_LOAD_BALANCER_ERROR,
};
